module.exports = "<gw-dynamic-component prefix=\"gwContactDetails\" variant=\"$ctrl.subtype\" props=\"$ctrl.args\"></gw-dynamic-component>"